'use client';
import React from 'react';
import { BNB_RATES } from '@/app/components/CurrencyCalculatorPage';
import { useLanguage } from '@/context/LanguageContext';
import { getTranslations } from '@/lib/i18n';

export default function RatesInfoCard() {
  const { language } = useLanguage();
  const t = getTranslations(language);

  return (
    <div className="card-sharp shadow-card p-5 sm:p-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-5">
        <div>
          <h2 className="text-base font-bold text-foreground">
            {t?.officialRates}
          </h2>
          <p className="text-sm text-muted-foreground mt-0.5">
            {t?.effectiveDate}
          </p>
        </div>
        <div className="flex items-center gap-2 bg-accent/10 border border-accent/30 rounded-md px-3 py-1.5 self-start sm:self-auto">
          <span className="w-2 h-2 rounded-full bg-accent inline-block"></span>
          <span className="text-xs font-semibold text-accent">
            {t?.ratesFixed}
          </span>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {/* EUR rate */}
        <div
          className="rounded-lg border p-4 flex items-center gap-3"
          style={{ backgroundColor: BNB_RATES?.EUR?.bgColor, borderColor: BNB_RATES?.EUR?.borderColor }}
        >
          <span className="text-3xl">🇪🇺</span>
          <div>
            <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">
              1 EUR =
            </p>
            <p className="text-2xl font-extrabold tabular-nums" style={{ color: BNB_RATES?.EUR?.color }}>
              1.95583 <span className="text-base font-bold">BGN</span>
            </p>
            <p className="text-xs text-muted-foreground mt-0.5">
              {t?.fixedEUParity}
            </p>
          </div>
        </div>

        {/* USD rate */}
        <div
          className="rounded-lg border p-4 flex items-center gap-3"
          style={{ backgroundColor: BNB_RATES?.USD?.bgColor, borderColor: BNB_RATES?.USD?.borderColor }}
        >
          <span className="text-3xl">🇺🇸</span>
          <div>
            <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">
              1 USD =
            </p>
            <p className="text-2xl font-extrabold tabular-nums" style={{ color: BNB_RATES?.USD?.color }}>
              1.85572 <span className="text-base font-bold">BGN</span>
            </p>
            <p className="text-xs text-muted-foreground mt-0.5">
              {t?.bnbMarketFixing}
            </p>
          </div>
        </div>

        {/* BGN inverse */}
        <div
          className="rounded-lg border p-4 flex items-center gap-3"
          style={{ backgroundColor: BNB_RATES?.BGN?.bgColor, borderColor: BNB_RATES?.BGN?.borderColor }}
        >
          <span className="text-3xl">🇧🇬</span>
          <div>
            <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">
              1 BGN =
            </p>
            <p className="text-2xl font-extrabold tabular-nums" style={{ color: BNB_RATES?.BGN?.color }}>
              0.51129 <span className="text-base font-bold">EUR</span>
            </p>
            <p className="text-xs text-muted-foreground mt-0.5">
              = 0.53887 USD
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}